import React, { useContext, useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

import done from "../Assets/Images/done.svg"
import cancel from "../Assets/Images/cancel.svg"
import delivaRedIcon from "../Assets/Images/deliva_red_icon.png"
import icon1 from "../Assets/Images/icon_1.png"
import icon2 from "../Assets/Images/icon_2.png"
import icon3 from "../Assets/Images/icon_3.png"
import icon4 from "../Assets/Images/icon_4.png"
import icon5 from "../Assets/Images/icon_5.png"
import googlePlayIcon from "../Assets/Images/google_play_icon.png"
import appleStoreIcon from "../Assets/Images/apple_store_icon.png"
import { Button } from '@material-ui/core';
import ModalContext from '../store/ModalContext';

const Authorize = () => {

  const { userId, phone: contactRef } = useParams();
  const [responseAuthorize, setResponseAuthorize]= useState("main");

  const [name, setName] = useState("");
  const [contactId, setContactId] = useState(contactRef);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apiBase = 'https://api.delivait.com/v3/user/panic/' + encodeURIComponent(userId) + '/contact';

  const modalCtx = useContext(ModalContext);

  const handleModal = (modal, data) => {    
    modalCtx.setDetails(modal, data);
    modalCtx.openModal();
  }

  useEffect(() => {
    getAuthorizeDetails();
	}, []);

  const getAuthorizeDetails = async () => {
    try {
      const response = await fetch('https://api.delivait.com/v3/user/panic/' + encodeURIComponent(userId) + '/contacts/' + encodeURIComponent(contactRef), {
        method: 'GET',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        setResponseAuthorize(response.status === 404 ? "notFound" : "error");
        setIsLoading(false);
        return;
      }

      if (data.data) setName(data.data);
      if (data.contactId) setContactId(data.contactId);

      if (data.message === "Contact is already declined.") {
        setResponseAuthorize("alreadyDeclined");
      } else if (data.message === "Contact is already authorized.") {
        setResponseAuthorize("alreadyAuthorized");
      }
      setIsLoading(false);
    } catch (err) {
      setResponseAuthorize("error");
      setIsLoading(false);
    }
  }

  const authorizeContact = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const response = await fetch(apiBase + '/' + encodeURIComponent(contactId) + '/authorize', {
        method: 'PUT',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        setResponseAuthorize(response.status === 404 ? "notFound" : "error");
        return;
      }

      if (data.code == 2000 && data.message === "Contact is already authorized.") {
        setResponseAuthorize("alreadyAuthorized");
      } else {
        setResponseAuthorize("confirm");
      }
    } catch (err) {
      setResponseAuthorize("error");
    } finally {
      setIsSubmitting(false);
    }
  }

  const declineContact = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const response = await fetch(apiBase + '/' + encodeURIComponent(contactId) + '/decline', {
        method: 'PUT',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        setResponseAuthorize(response.status === 404 ? "notFound" : "error");
        return;
      }

      if (data.code == 2000 && data.message === "Contact is already declined.") {
        setResponseAuthorize("alreadyDeclined");
      } else {
        setResponseAuthorize("decline");
        handleModal("decline-authorize", name);
      }
    } catch (err) {
      setResponseAuthorize("error");
    } finally {
      setIsSubmitting(false);
    }
  }

  if(isLoading) {
    return (
      <div className='authorize-page'>
        <div className='authorize-loading'>
          <CircularProgress style={{ color: '#e74c3d' }} />
        </div>
      </div>
    )
  }

  return (
    <div className='authorize-page'>
      {/* Top White Section */}
      <div className='authorize-top'>
        <img src={delivaRedIcon} alt="deliva" className='authorize-logo-img' />

        {responseAuthorize === "main" && (
          <div className='authorize-content'>
            <p className='main-text'>
              {name} wants to add you as an emergency{'\u00A0'}contact.
            </p>
            <p className='sub-text'>
              When the panic button is triggered, you will receive an immediate alert
              and live location updates.
            </p>
            <p className='consent-text'>
              By accepting, you agree to receive emergency alerts and location updates when{' '}
              {name} needs help.
            </p>
            <div className='authorize-buttons'>
              <Button
                variant='outlined'
                className='decline-btn'
                disabled={isSubmitting}
                onClick={() => declineContact()}
              >
                Decline
              </Button>
              <Button
                variant='contained'
                className='accept-btn'
                disabled={isSubmitting}
                onClick={() => authorizeContact()}
              >
                Accept
              </Button>
            </div>
          </div>
        )}

        {responseAuthorize === "notFound" && (
          <div className='authorize-response'>
            <img src={cancel} alt="Not found" className="decline-icon" />
            <span className='response-title'>This request is no longer available.</span>
            <p>The emergency contact request linked here has been removed or replaced. Ask the person who invited you to send a new request.</p>
          </div>
        )}

        {responseAuthorize === "error" && (
          <div className='authorize-response'>
            <img src={cancel} alt="Error" className="decline-icon" />
            <span className='response-title'>Something went wrong.</span>
            <p>We could not complete your request. Please check your connection and open the link again.</p>
          </div>
        )}

        {responseAuthorize === "confirm" && (
          <div className='authorize-response'>
            <img src={done} alt="Success" />
            <span className='response-title'>Thank You!</span>
            <p>You have now been authorized as an emergency contact for {name}.</p>
          </div>
        )}

        {responseAuthorize === "decline" && (
          <div className='authorize-response'>
            <img src={cancel} alt="Declined" className="decline-icon" />
            <span className='response-title'>Declined!</span>
            <p>You have declined as an emergency contact for {name}.</p>
          </div>
        )}

        {responseAuthorize === "alreadyAuthorized" && (
          <div className='authorize-response'>
            <img src={done} alt="Success" />
            <span className='response-title'>You have already accepted the request to be added as an emergency contact.</span>
            <p>There is no more action required from you.</p>
          </div>
        )}

        {responseAuthorize === "alreadyDeclined" && (
          <div className='authorize-response'>
            <img src={cancel} alt="Declined" className="decline-icon" />
            <span className='response-title'>You declined the request to be added as an emergency contact.</span>
            <p>There is no more action required from you. You will not receive any alerts from {name || 'this user'}.</p>
            <p>If you've changed your mind and would like to accept the request now, click on <strong>Accept</strong> below.</p>
            <div className='authorize-buttons'>
              <Button variant='contained' className='accept-btn' disabled={isSubmitting} onClick={() => authorizeContact()}>Accept</Button>
            </div>
          </div>
        )}
      </div>

      {/* Bottom Red Section */}
      <div className='authorize-bottom'>
        <h2 className='features-title'>What happens during emergency:</h2>
        
        <div className='features-grid'>
          <div className='feature-item'>
            <img src={icon1} alt="" className='feature-icon-img' />
            <p className='feature-label'>Instant Alerts<br/><span>(SMS, WhatsApp & More)</span></p>
          </div>

          <div className='feature-item'>
            <img src={icon2} alt="" className='feature-icon-img' />
            <p className='feature-label'>Live Location Tracking</p>
          </div>

          <div className='feature-item'>
            <img src={icon3} alt="" className='feature-icon-img' />
            <p className='feature-label'>One-Tap Panic Button</p>
          </div>

          <div className='feature-item'>
            <img src={icon4} alt="" className='feature-icon-img' />
            <p className='feature-label'>Works Without Internet<br/><span>*Works only on android with a valid sim pack</span></p>
          </div>

          <div className='feature-item'>
            <img src={icon5} alt="" className='feature-icon-img' />
            <p className='feature-label'>Works In 102+ Countries</p>
          </div>
        </div>

        <div className='download-section'>
          <p className='download-text'>Download the app yourself to access the <strong>Free Panic Button</strong></p>
          <div className='store-buttons'>
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" className='store-btn'>
              <img src={googlePlayIcon} alt="Get it on Google Play" className='store-btn-img' />
            </a>
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className='store-btn'>
              <img src={appleStoreIcon} alt="Download on the App Store" className='store-btn-img' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Authorize